import { assert } from '@/core'
import { BaseService } from './base.service'
import { ResponseWrapper } from './util'

export class DoctorsService extends BaseService {
  static get entity() {
    return 'doctors'
  }
  static async getList(parameters = {}) {
    assert.object(parameters)

    const params = { ...parameters }

    const response = await this.request({ auth: true }).get(`doctors/kiosk/all`, { params })


    return new ResponseWrapper(response, response.data.data)

  }
  static async getSyncDoctors(parameters = {}) {
    assert.object(parameters)
    const params = { ...parameters }
    const response = await this.request({ auth: true }).get(`sync/doctors`, { params })
    return new ResponseWrapper(response, response.data.data)
  }

  static async findDoctor(parameters = {}) {
    assert.object(parameters)

    const params = { ...parameters }

    console.log("🚀 ~ DoctorsService ~ findDoctor ~ params:", params)
    const response = await this.request({ auth: true }).get(`sync/doctors/one`, { params })

    return new ResponseWrapper(response, response.data.data)

  }

  /**
   * Creates a doctor with the provided data, including dynamically generated slots.
   * @param {Object} data - The doctor details with working days and time slots.
   * @returns {Promise<ResponseWrapper>} - The response wrapper containing the API response.
   */
  static async create(data = {}) {
    assert.object(data, { required: true })
    const response = await this.request({ auth: true }).post(`/sync/doctors`, data);
    return new ResponseWrapper(response, response.data.data);
  }

  static async getById(id , parameters = {}) {
    assert.string(id, { required: true })
    assert.object(parameters)

    const params = { ...parameters }
    const response = await this.request({ auth: true }).get(`doctors/${id}`, {params})
    return new ResponseWrapper(response, response.data.data)

  }
}
